export default "__VITE_PUBLIC_ASSET__1ebd0385__"